'use client';

import { useConnectivity } from '@/ueshook/useConnectivity';
import { useEffect } from 'react';
import { toast } from 'sonner';

const GoogleConnectivity = () => {
  const { isGoogleAccessible, isLoading, isOnline } = useConnectivity(
    true,
    60000
  );

  useEffect(() => {
    if (!isOnline) {
      toast.error('Network is offline, please check your network');
      return;
    }
    if (isLoading || isGoogleAccessible === null || isGoogleAccessible) return;
    if (isGoogleAccessible === false) {
      toast.error(
        'Network error, please check your network, and ensure you can access the internet'
      );
      return;
    }
  }, [isGoogleAccessible, isLoading, isOnline]);

  return null;
};

export default GoogleConnectivity;
